import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function realTimeSenderReducer(state = initialState.realTimeSendMessage , action) {
    if (action.type === types.READ_RALTIME_MESSAGE_SEND)
    {
        return action.realTimeSendMessage;
    }
    else {
        return state;
    }
}
